import script from "./PriceSearchCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceSearchCard.vue?vue&type=script&lang=ts&setup=true"

import "./PriceSearchCard.vue?vue&type=style&index=0&id=0e07fe48&lang=scss"

const __exports__ = script;

export default __exports__